import cx from 'classnames';
import PropTypes from 'prop-types';

import { ImageFrame } from 'src/components/ImageFrame';

import { useStyles } from './useStyles';

const propTypes = {
  className: PropTypes.string,
  images: PropTypes.arrayOf(
    PropTypes.shape({
      index: PropTypes.number.isRequired,
      url: PropTypes.string.isRequired,
    })
  ).isRequired,
};
const defaultProps = {
  className: '',
};

export const CardImages = ({ className, images }) => {
  const styles = useStyles();

  const visibleImages = images.slice(0, 4);

  return (
    <div
      className={cx(styles.root, className)}
      data-image-count={visibleImages.length}
    >
      {visibleImages.map((image) => (
        <ImageFrame
          className={styles.image}
          key={image.index}
          src={image.url}
        />
      ))}
    </div>
  );
};
CardImages.displayName = 'CardImages';
CardImages.propTypes = propTypes;
CardImages.defaultProps = defaultProps;
